import { render, staticRenderFns } from "./WidgetSocios.vue?vue&type=template&id=3154e46b&lang=pug&"
import script from "./WidgetSocios.vue?vue&type=script&lang=js&"
export * from "./WidgetSocios.vue?vue&type=script&lang=js&"
import style0 from "./WidgetSocios.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports